var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    { staticClass: "px-0" },
    [
      _vm.comment.user && _vm.comment.user.image
        ? _c("v-list-item-avatar", [
            _c("img", { attrs: { src: _vm.comment.user.image.url } }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        { staticClass: "d-block" },
        [
          !_vm.comment.isEditing
            ? [
                _c("div", {
                  class: "html-body comment-html-body-" + _vm.comment.id,
                  domProps: { innerHTML: _vm._s(_vm.comment.renderedBody) },
                }),
                _vm._v(" "),
                _vm.comment.user &&
                _vm.user &&
                _vm.comment.user.id == _vm.user.id
                  ? _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("v-col", { attrs: { cols: "12" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "me-2",
                              on: {
                                click: function ($event) {
                                  _vm.comment.isEditing = true
                                },
                              },
                            },
                            [_vm._v("編集")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.deleteComment(_vm.comment.id)
                                },
                              },
                            },
                            [_vm._v("消去")]
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c("Simplemde", {
                  attrs: { rows: 3, name: "comment-body-new" },
                  model: {
                    value: _vm.comment.body,
                    callback: function ($$v) {
                      _vm.$set(_vm.comment, "body", $$v)
                    },
                    expression: "comment.body",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-block" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "me-2",
                        attrs: { color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.updateComment(_vm.comment)
                          },
                        },
                      },
                      [_vm._v("コメントを送信する")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function ($event) {
                            _vm.comment.isEditing = false
                          },
                        },
                      },
                      [_vm._v("キャンセル")]
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }